import { render, staticRenderFns } from "./assistant-rich-text.vue?vue&type=template&id=bc26f5e0&scoped=true"
import script from "./assistant-rich-text.vue?vue&type=script&lang=js"
export * from "./assistant-rich-text.vue?vue&type=script&lang=js"
import style0 from "./assistant-rich-text.vue?vue&type=style&index=0&id=bc26f5e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc26f5e0",
  null
  
)

export default component.exports